import { addDays, isAfter } from "date-fns";

export interface DaysInRangeProps {
  startDate: Date;
  endDate: Date;
}

export function getDaysInRange(props: DaysInRangeProps): Date[] {
  const { startDate, endDate } = props;
  const output: Date[] = [];

  let currentDate = startDate;
  while (!isAfter(currentDate, endDate)) {
    output.push(currentDate);
    currentDate = addDays(currentDate, 1);
  }

  return output;
}
